import {MailCheck} from 'lucide-react'

interface VerifyEmailInfoProps {
  email: string
}

export function VerifyEmailInfo({email}: VerifyEmailInfoProps) {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <MailCheck className="size-10 text-primary" strokeWidth={1.5} />
      <p className="text-sm text-muted-foreground">
        Ссылка для подтверждения отправлена на <strong className="text-foreground">{email}</strong>.
        <br />
        Перейдите по ней, чтобы активировать аккаунт.
      </p>
    </div>
  )
}
